/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  SendInvUpgradeInput,
  SendInvUpgradeResponse,
} from '..';
import {
  serializeSendInvUpgradeInput,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface SendInvUpgradeForWebInput {
  input: SendInvUpgradeInput;
}
const build = (_query: DocumentNode, input: SendInvUpgradeForWebInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.input !== undefined ? `$input: SendInvUpgradeInput = ${serializeSendInvUpgradeInput(input.input)}` : '' ) + `){
    sendInvUpgradeForWeb(
      ${ input.input !== undefined ? 'input: $input,' : '' }
    ){
      ...sendinvupgraderesponse
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class SendInvUpgradeForWebMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment sendinvupgraderesponse on SendInvUpgradeResponse { ... }
   */
  async execute(_query: DocumentNode, input: SendInvUpgradeForWebInput): Promise<apollo.FetchResult< { sendInvUpgradeForWeb: Partial<SendInvUpgradeResponse> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ sendInvUpgradeForWeb: Partial<SendInvUpgradeResponse> }>({ mutation: build(_query, input) });
  }
}
